module.exports = "<ul class=\"nav nav-tabs\" role=\"tablist\">\r\n  <ng-content></ng-content>\r\n</ul>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/framework/spk/layouts/tabs/spk-tabs/spk-tabs.component.html
// module id = ./src/app/components/framework/spk/layouts/tabs/spk-tabs/spk-tabs.component.html
// module chunks = main